import { useSelector } from 'react-redux';
import { useGetVendorsQuery } from '../redux/rtk/vendors.services';
import { currentUserCompanyId } from '../redux/selectors/userDataSelectors';

export default function useVendorContracts() {
  const userCompany = useSelector(currentUserCompanyId);
  const {
    isFetching,
    isLoading,
    data: vendors,
  } = useGetVendorsQuery(userCompany, { skip: !userCompany });

  const flattenConfig = vendors
    ?.map(vendor => vendor.contracts.map(contract => contract.setting.orders))
    .flat(2)
    .filter(order => order !== 'service_order');

  const config = new Set(flattenConfig);
  const _isLoading = isFetching || isLoading;

  return {
    isLoading: _isLoading,
    hasTwoTypes: config.size === 2,
    hasWorkOrder: config.has('work_order'),
    hasReconditioning: config.has('reconditioning'),
    hasServiceOrder: config.has('service_order'),
  };
}
